import { Alert, Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import Carousel from "../Tools/Carousel";
import { useContext } from "react";
import UserContext from "../../services/Context/UserContext";
import Address from "../Inputs/Address"
import { LoadingButton } from "@mui/lab";
import { useEffect } from "react";
import API from "../../services/API";
import { ArrowBack, Close } from "@mui/icons-material";
import Frame from "../Frames/Basic";
import Loader from "../Tools/Loader";
import Chat from "../Tools/Chat";
import { Link } from "react-router-dom";

export default function Form(){

    const {user} = useContext(UserContext)

    const [status, setStatus] = useState('loading')

    const statusIs = str => str === status

    const statusIn = arr => arr.includes(status)

    const [rewards, setRewards] = useState([])

    const [reward, setReward] = useState(null)

    const [contact, setContact] = useState({})

    const [message, setMessage] = useState('')

    useEffect(() => {

        API.get(`/rewards`)
            .then(r => {

                if(Array.isArray(r.data) && r.data.length > 0){

                    setRewards(r.data)
                    setContact(user)
                    setStatus('ready')
                        
                }else{

                    setStatus('error')
                }
            })
            .catch(e => setStatus('error'))


    }, [user])

    const handleSubmit = e => {
        e.preventDefault();

        setStatus('submit')

        const order = {user: contact, products: [reward]}

        API.post('/rewards/order', order)
            .then(r => {
                setMessage(r.data.message)
                setStatus('success')
                window.localStorage.removeItem('reward')
            })
            .catch(e => {
                setStatus('fail')
                setMessage(e.response?.data?.message)
            })
    }

    const handleChoose = reward => {
        setReward(reward)
        setStatus(reward ? 'chosen' : 'ready')
    }

    return <Frame>
        
        <Stack spacing={3} sx={{maxWidth: 600}}>

            <Typography variant='h1'>🎁 Votre récompense</Typography>

            {statusIs('loading') &&
                <Loader />
            }

            {statusIs('error') && 
                <Typography>Aucune récompense n'est disponible actuellement.</Typography>
            }

            {statusIs('ready') && <>

                <Typography>
                    Choisissez votre cadeau dans la liste ci-dessous :
                </Typography>


                <Carousel
                    items={rewards}
                    itemsPerPage={1}
                    renderItem={i => 
                        <img 
                            key={i.id}
                            src={i.picture?.url}
                            alt={i.title}
                            width={200}
                            onClick={() => handleChoose(i)}
                            style={{cursor: 'pointer', border: 'solid 1px lightgrey', borderRadius: '5px'}}
                        />
                    }
                />
            
            </>}

            {statusIn(['chosen','submit','fail']) &&

                <form onSubmit={handleSubmit}>
                    
                    <Stack spacing={2}>

                        <Stack direction='row' alignItems='start' justifyContent='center' spacing={1}>

                            <img 
                                key={reward.id}
                                src={reward.picture?.url}
                                alt={reward.title}
                                width={200}
                                style={{border: 'solid 1px lightgrey', borderRadius: '5px'}}
                            />

                            <IconButton onClick={() => handleChoose(null)}>
                                <Close />
                            </IconButton>

                        </Stack>

                        <Typography>Veuillez confirmer vos coordonnées pour obtenir votre récompense :</Typography>

                        <TextField 
                            label="Email"
                            type='email'
                            size='small'
                            value={contact.email}
                            onChange={e => setContact({...contact, email: e.target.value})}
                            required
                        />
                        
                        <Address 
                            value={contact}
                            onChange={data => setContact(data)}
                        />

                        <LoadingButton
                            loading={statusIs('submit')}
                            type='submit'
                            variant='contained'
                        >
                            Valider
                        </LoadingButton>

                        {statusIs('fail') && 
                            <Alert severity='error'>
                                {message || "Une erreur s'est produite."}
                            </Alert>
                        }

                    </Stack>
                </form>
            }

            {statusIs('success') && 
            
                <Alert severity='success'>{message}</Alert>
            }

            <Link to='/'>
                <Button startIcon={<ArrowBack />}>Retour à l'accueil</Button>
            </Link>

        </Stack>

        <Chat />

    </Frame>
}